// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__3221z","header":"ReportDetails_header__18TAL","title":"ReportDetails_title__2fOxT","left":"ReportDetails_left__1391J"};